import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="selectbox"
// Handles custom select box interactions (replaces enableSelectBoxes jQuery function)
export default class extends Controller {
  static targets = ["selected", "arrow", "options"]
  static values = {
    targetInputSelector: { type: String, default: ".quiz-size" }
  }

  connect() {
    // Initialize selected text from first option
    const firstOption = this.element.querySelector('span.selectOption')
    if (firstOption) {
      const selectedElement = this.element.querySelector('span.selected')
      if (selectedElement) {
        selectedElement.textContent = firstOption.textContent
      }
      // Set initial value attribute
      const firstValue = firstOption.getAttribute('value')
      if (firstValue) {
        this.element.setAttribute('value', firstValue)
        // Update target input if it exists
        this.updateTargetInput(firstValue)
      }
    }
  }

  toggle(event) {
    event.preventDefault()
    const optionsDiv = this.element.querySelector('div.selectOptions')
    if (optionsDiv) {
      const isHidden = optionsDiv.style.display === 'none' ||
                       window.getComputedStyle(optionsDiv).display === 'none'
      optionsDiv.style.display = isHidden ? 'block' : 'none'
    }
  }

  select(event) {
    event.preventDefault()
    const option = event.currentTarget
    const optionsDiv = this.element.querySelector('div.selectOptions')
    const selectedElement = this.element.querySelector('span.selected')

    if (optionsDiv && selectedElement) {
      // Hide dropdown
      optionsDiv.style.display = 'none'

      // Update selectBox value
      const value = option.getAttribute('value')
      if (value) {
        this.element.setAttribute('value', value)
      }

      // Update selected text
      selectedElement.textContent = option.textContent

      // Update target input (e.g., .quiz-size)
      if (value) {
        this.updateTargetInput(value)
      }
    }
  }

  updateTargetInput(value) {
    const targetInput = document.querySelector(this.targetInputSelectorValue)
    if (targetInput) {
      targetInput.setAttribute('value', value)
    }
  }
}
